import type { TemplateSearchResult } from '@/lib/templates/types'
import type { TemplateSnapshot } from './types'

export function toTemplateSnapshot(
  hit: TemplateSearchResult
): TemplateSnapshot {
  return {
    emailId: hit.emailId,
    ...(hit.publicPath ? { publicPath: hit.publicPath } : {}),
    title: hit.title,
    category: hit.category,
    imagePngUrl: hit.imagePngUrl,
    brandDomain: hit.brandDomain,
    updatedAt: hit.updatedAt,
  }
}
